function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19,6a5,5,0,0,0-5-5A5,5,0,0,1,19,6Z",
  fill: "#afafaf"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6,1A5,5,0,0,0,1,6,5,5,0,0,1,6,1Z",
  fill: "#afafaf"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14,2H6A4,4,0,0,0,2,6v8a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4V6A4,4,0,0,0,14,2ZM9.4,13.37a.71.71,0,0,1-.53.22h0a.75.75,0,0,1-.53-.22L5.53,10.49,6.61,9.44l2.27,2.34L14,6.63l1.06,1.06Z",
  fill: "#afafaf"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14,19a5,5,0,0,0,5-5A5,5,0,0,1,14,19Z",
  fill: "#afafaf"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1,14a5,5,0,0,0,5,5A5,5,0,0,1,1,14Z",
  fill: "#afafaf"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14,1H6A5,5,0,0,0,1,6v8a5,5,0,0,0,5,5h8a5,5,0,0,0,5-5V6A5,5,0,0,0,14,1Zm4,13a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V6A4,4,0,0,1,6,2h8a4,4,0,0,1,4,4Z",
  fill: "#e0e0e0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.88,11.78,6.61,9.44,5.53,10.49l2.81,2.88a.75.75,0,0,0,.53.22h0a.71.71,0,0,0,.53-.22l5.69-5.68L14,6.63Z",
  fill: "#fff"
});

var SvgCheckboxSmallPartlyChecked = function SvgCheckboxSmallPartlyChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckboxSmallPartlyChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkbox_small_partly_checked.c4f7c207.svg";
export { ForwardRef as ReactComponent };